"use client"

import { useState } from "react"
import "../styles/Modal.css"
import { saveInquiry } from "../api/inquiries"

export default function Modal({
  isOpen,
  onClose,
  title = "BOOK A SITE VISIT",
  selectedImage,
  showImage,
  setShowImage,
}) {
  const [formData, setFormData] = useState({
    name: "",
    phone: "",
    email: "",
    consent: false,
  })
  const [errors, setErrors] = useState({})
  const [loading, setLoading] = useState(false)

  if (!isOpen) return null

  // ✅ Input change with validation cleanup and phone restriction
  const handleChange = (e) => {
    const { name, value, type, checked } = e.target

    if (name === "phone") {
      const cleanedValue = value.replace(/\D/g, "") // allow only digits
      if (cleanedValue.length <= 10) {
        setFormData((prev) => ({ ...prev, phone: cleanedValue }))
      }
      return
    }

    setFormData((prev) => ({
      ...prev,
      [name]: type === "checkbox" ? checked : value,
    }))

    // Clear errors while typing
    setErrors((prev) => ({ ...prev, [name]: "" }))
  }

  // ✅ Validation logic
  const validateForm = () => {
    const newErrors = {}

    if (!formData.name.trim()) {
      newErrors.name = "Name is required"
    } else if (!/^[A-Za-z\s]+$/.test(formData.name.trim())) {
      newErrors.name = "Name can only contain letters and spaces"
    }

    if (!formData.phone.trim()) {
      newErrors.phone = "Phone number is required"
    } else if (formData.phone.length !== 10) {
      newErrors.phone = "Please enter a valid 10-digit number"
    }

    if (!formData.email.trim()) {
      newErrors.email = "Email is required"
    } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(formData.email)) {
      newErrors.email = "Please enter a valid Email address"
    }

    if (!formData.consent) {
      newErrors.consent = "Please accept the consent to proceed"
    }

    setErrors(newErrors)
    return Object.keys(newErrors).length === 0
  }

  // ✅ Handle submit
  const handleSubmit = async (e) => {
    e.preventDefault()

    if (!validateForm()) {
      return
    }

    const now = new Date()
    const offsetMs = 5.5 * 60 * 60 * 1000 // IST = UTC + 5:30
    const istTime = new Date(now.getTime() + offsetMs)
    const inquiry_datetime = istTime.toISOString().replace("T", " ").split(".")[0]
    const payload = { inquiry_datetime, ...formData }

    setLoading(true)
    try {
      await saveInquiry(payload)
      alert("Thank you for your interest! We will contact you soon.")
      if (selectedImage) {
        setShowImage(true)
      } else {
        onClose()
      }
    } catch (err) {
      console.error(err)
      alert("Failed to submit inquiry. Please try again later.")
    } finally {
      setLoading(false)
    }
  }

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div
        className={`modal-content ${showImage ? "image-view" : ""}`}
        onClick={(e) => e.stopPropagation()}
      >
        <button className="modal-close" onClick={onClose}>
          ✕
        </button>

        {!showImage ? (
          <>
            <div className="modal-header">
              <div className="modal-logo">Ashtech Presidential Towers</div>
              <p className="modal-location">
                3/4 BHK Apartment in Greater Noida West
              </p>
            </div>

            <form onSubmit={handleSubmit} className="modal-form">
              <input
                type="text"
                name="name"
                placeholder="Enter Name"
                value={formData.name}
                onChange={handleChange}
              />
              {errors.name && <p className="error">{errors.name}</p>}

              <input
                type="tel"
                name="phone"
                placeholder="Enter Phone Number"
                value={formData.phone}
                onChange={handleChange}
              />
              {errors.phone && <p className="error">{errors.phone}</p>}

              <input
                type="email"
                name="email"
                placeholder="Enter Email ID"
                value={formData.email}
                onChange={handleChange}
              />
              {errors.email && <p className="error">{errors.email}</p>}

              <div className="consent-checkbox">
                <input
                  type="checkbox"
                  id="consent"
                  name="consent"
                  checked={formData.consent}
                  onChange={handleChange}
                />
                <label htmlFor="consent">
                  I authorize company representatives to Call, SMS, Email or
                  WhatsApp me about its products and offers. This consent
                  overrides any registration for DNC/NDNC.
                </label>
              </div>
              {errors.consent && <p className="error">{errors.consent}</p>}

              <button type="submit" className="model-submit-btn" disabled={loading}>
                {loading ? "Submitting..." : "SUBMIT NOW"}
              </button>
            </form>
          </>
        ) : (
          <div className="floorplan-image-container">
            <img
              src={selectedImage}
              alt="Floor Plan"
              className="floorplan-full-image"
            />
          </div>
        )}
      </div>
    </div>
  )
}


// "use client"

// import { useState } from "react"
// import "../styles/Modal.css"
// import { saveInquiry } from "../api/inquiries"

// export default function Modal({ isOpen, onClose, title = "BOOK A SITE VISIT", selectedImage, showImage, setShowImage }) {
//   const [formData, setFormData] = useState({
//     name: "",
//     phone: "",
//     email: "",
//     consent: false,
//   })
//   const [loading, setLoading] = useState(false)

//   if (!isOpen) return null

//   const handleChange = (e) => {
//     const { name, value, type, checked } = e.target
//     setFormData((prev) => ({
//       ...prev,
//       [name]: type === "checkbox" ? checked : value,
//     }))
//   }

//   const handleSubmit = async (e) => {
//     e.preventDefault()
//     // const inquiry_datetime = new Date().toISOString().replace("T", " ").split(".")[0]
//     const now = new Date()
//     const offsetMs = 5.5 * 60 * 60 * 1000 // IST = UTC + 5 hours 30 mins
//     const istTime = new Date(now.getTime() + offsetMs)
//     const inquiry_datetime = istTime.toISOString().replace("T", " ").split(".")[0]
//     const payload = { inquiry_datetime, ...formData }

//     setLoading(true)
//     try {
//       await saveInquiry(payload)
//       alert("Thank you for your interest! We will contact you soon.")
//       // setShowImage(true) // show image instead of closing
//       if (selectedImage) {
//         setShowImage(true) // show image if available
//       } else {
//         onClose() // close modal if no image to show
//       }
//     } catch (err) {
//       console.error(err)
//       // alert("Failed to submit inquiry. Please try again later.")
//     } finally {
//       setLoading(false)
//     }
//   }

//   return (
//     <div className="modal-overlay" onClick={onClose}>
//       <div className={`modal-content ${showImage ? "image-view" : ""}`} onClick={(e) => e.stopPropagation()}>
//         <button className="modal-close" onClick={onClose}>✕</button>

//         {!showImage ? (
//           <>
//             <div className="modal-header">
//               <div className="modal-logo">Ashtech Presidential Towers</div>
//               <p className="modal-location">3/4 BHK Apartment in Greater Noida West</p>
//             </div>

//             <form onSubmit={handleSubmit} className="modal-form">
//               <input type="text" name="name" placeholder="Enter Name" value={formData.name} onChange={handleChange} required />
//               <input type="tel" name="phone" placeholder="Enter Mobile Number" value={formData.phone} onChange={handleChange} required pattern="\d{10}" title="Please enter a 10-digit mobile number" />
//               <input type="email" name="email" placeholder="Enter Email ID" value={formData.email} onChange={handleChange} required />

//               <div className="consent-checkbox">
//                 <input type="checkbox" id="consent" name="consent" checked={formData.consent} onChange={handleChange} required />
//                 <label htmlFor="consent">
//                   I authorize company representatives to Call, SMS, Email or WhatsApp me about its products and offers. This consent overrides any registration for DNC/NDNC.
//                 </label>
//               </div>

//               <button type="submit" className="model-submit-btn" disabled={loading}>
//                 {loading ? "Submitting..." : "SUBMIT NOW"}
//               </button>
//             </form>
//           </>
//         ) : (
//           <div className="floorplan-image-container">
//             <img src={selectedImage} alt="Floor Plan" className="floorplan-full-image" />
//           </div>
//         )}
//       </div>
//     </div>
//   )
// }